import React, {Component} from 'react';
import { connect } from 'react-redux';

import Loading from 'components/Loading';
import HeaderNotification from 'components/notification/HeaderNotification';
import ItemNotificationList from 'components/notification/ItemNotificationList';

import {t, dt} from 'l10n';

import '../../sass/notificationList.scss';

import { 
    getMemberNotificationList,
    getMemberNotificationListMore,
    applyMemberNotificationAction,
    } from 'reducers/memberNotificationList';

class memberNotificationList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pendingScroll: false,
            showTopButton: false,
        };

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;

        let action = getMemberNotificationList();
        dispatch(action);
                
        action.promise
            .then((res) => {
                this.readItems(res.data.data.list);
                this.setState({pendingScroll: false})
            })
            .catch((e) => this.setState({pendingScroll: false}));

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(e) {
        const {
            scrollTop,
            scrollHeight,
            clientHeight,
        } = e.target.scrollingElement;
        let innerHeight = window.innerHeight;
        const bottom = scrollHeight - Math.floor(scrollTop + innerHeight) <= 2;
        const {
            offset,
            totalCount
        } = this.props.memberNotificationList;

        this.setState({showTopButton: scrollTop !== 0});

        if(scrollTop !== 0 && bottom && offset !== totalCount) {
            const { dispatch, location } = this.props;

            const params = {
                offset: offset
            };

            this.setState({pendingScroll: true});

            let action = getMemberNotificationListMore(params);
            dispatch(action);
                    
            action.promise
                .then((res) => {
                    this.readItems(res.data.data.list);
                    this.setState({pendingScroll: false})
                })
                .catch((e) => this.setState({pendingScroll: false}));
        }
    }

    readItems(list) {
        const { dispatch } = this.props;

        const arr = list.filter(item => item.data.is_read === 0).map(item => item.data.id);

        if(!arr.length) return false;

        const params = {
            ids: arr,
            action: 'read'
        };

        dispatch(applyMemberNotificationAction(params));
    }

    render() {
        if (!this.props.memberNotificationList.list) return <Loading centered/>;

        const { pendingScroll } = this.state;

        const { list } = this.props.memberNotificationList;

        return (
            <div id="wrapper">
                <HeaderNotification title={dt('notifications','Notification services')}/>

                <aside className="notification-list">
                    <div className={`content ${list.length ? 'paddingTop' : ''}`}>
                        {list.length ? <ItemNotificationList list={list}/> : (
                            <div className="list-empty">
                                {dt('notifications','No notifications at the moment.')}
                            </div>
                        )}
                    </div>
                    {pendingScroll ? <Loading /> : null}
                </aside>

            </div>
        )
    }
}

export default connect(
    state => ({
        memberNotificationList: state.memberNotificationList
    }),
    null
)(memberNotificationList);


// WEBPACK FOOTER //
// ./src/containers/member/MemberNotificationList.js